module.exports = __webpack_public_path__ + "static/media/realbrand_logo.3a050143.png";